<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <!-- <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} Cấp mã MS</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} Cấp mã MS</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} Cấp mã MS</span>-->
        <span>Cấp mã thẻ du lịch</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row class="mt-3 mb-3">
            <b-col md="2">
              <b-link
                class="el-button el-button--info el-button--small is-plain"
                :href="aExtension.urlFilesTemplate.DsKDLMau"
              >
                <i class="fa fa-download"></i> File excel mẫu
              </b-link>
            </b-col>
            <b-col md="6">
              <el-upload
                action
                :auto-upload="false"
                list-type="text"
                :limit="mData.fileUploadOption.DsKhachDuLich.limit"
                :accept="mData.fileUploadOption.DsKhachDuLich.accept"
                :on-change="fn_uploadChangeDsKhachDuLich"
                :on-exceed="fn_uploadExceedDsKhachDuLich"
                :file-list="mData.fileUploadOption.DsKhachDuLich.fileList"
                :disabled="mData.viewMode == 'detail'"
                multiple
              >
                <el-button size="small" type="info" plain>
                  <i class="fa fa-upload"></i> Upload file
                </el-button>
              </el-upload>
            </b-col>
          </b-row>

          <el-alert
            class="mb-2"
            title="Vui lòng kiểm tra lại dữ liệu tải lên!"
            type="error"
            show-icon
            v-if="mData.dialogKhachDuLich.hasError"
          ></el-alert>

          <el-table
            :data="mData.dialogKhachDuLich.list"
            border
            max-height="400"
            style="width: 100%"
            :row-class-name="fn_errorRow"
          >
            <el-table-column type="expand" v-if="mData.dataDefault.sended">
              <template slot-scope="props">
                <p
                  :style="{
                    color: props.row.reason
                      ? mData.dataDefault.color.error
                      : mData.dataDefault.color.active,
                    'margin-bottom': 0,
                  }"
                >
                  {{ props.row.status }}
                </p>
                <p
                  style="color: #f53131; margin-bottom: 0"
                  v-if="props.row.reason"
                >
                  Ghi chú: {{ props.row.reason }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_stt"
              label="STT"
              align="center"
              width="50"
            ></el-table-column>
            <el-table-column prop="excel_ho_dem" label="Họ đệm" min-width="150">
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_ho_dem',
                      scope.row.excel_ho_dem
                    )
                  "
                  >{{ scope.row.excel_ho_dem }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_ten"
              label="Tên"
              min-width="100"
              width="auto"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_ten',
                      scope.row.excel_ten
                    )
                  "
                  >{{ scope.row.excel_ten }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_ngay_sinh"
              label="Ngày sinh"
              align="right"
              width="100"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_ngay_sinh',
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_ngay_sinh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_thang_sinh"
              label="Tháng sinh"
              align="right"
              width="100"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_thang_sinh',
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_thang_sinh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_nam_sinh"
              label="Năm sinh"
              align="right"
              width="100"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_nam_sinh',
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_nam_sinh }}</span
                >
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="excel_ngay_sinh"
              label="Ngày sinh"
              align="center"
              width="120"
            >              
            </el-table-column>-->
            <el-table-column
              prop="excel_gioi_tinh"
              label="Giới tính"
              align="center"
              width="60"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_gioi_tinh',
                      scope.row.excel_gioi_tinh
                    )
                  "
                  >{{ scope.row.excel_gioi_tinh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_loai_giay_to"
              label="Loại giấy tờ"
              align="center"
              width="80"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_loai_giay_to',
                      scope.row.excel_loai_giay_to,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_loai_giay_to }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_so_giay_to"
              label="Số giấy tờ"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_so_giay_to',
                      scope.row.excel_so_giay_to,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_so_giay_to }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_dien_thoai"
              label="Số điện thoại"
              align="left"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="excel_so_the_bhyt"
              label="Số thẻ BHYT"
              align="center"
              width="100"
            ></el-table-column>

            <el-table-column
              prop="excel_quoc_tich"
              label="Quốc tịch"
              align="left"
              width="120"
            >
              <!-- <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelKhachDuLich('excel_ngay_sinh', scope.row.excel_ngay_sinh, scope.row.excel_thang_sinh, scope.row.excel_nam_sinh)"
                >{{scope.row.excel_ngay_sinh}}</span>
              </template>-->
            </el-table-column>

            <el-table-column
              prop="excel_ma_quoc_gia"
              label="Mã quốc gia"
              align="center"
              width="100"
            >
              <!-- <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelKhachDuLich('excel_nam_sinh', scope.row.excel_nam_sinh)"
                >{{scope.row.excel_nam_sinh}}</span>
              </template>-->
            </el-table-column>
            <el-table-column
              prop="excel_ho_dem_ngh"
              label="Họ đệm (người giám hộ)"
              min-width="150"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_ho_dem_ngh',
                      scope.row.excel_ho_dem_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_ho_dem_ngh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_ten_ngh"
              label="Tên (người giám hộ)"
              min-width="100"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_ten_ngh',
                      scope.row.excel_ten_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_ten_ngh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_ngay_sinh_ngh"
              label="Ngày sinh (người giám hộ)"
              align="right"
              width="150"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_ngay_sinh_ngh',
                      scope.row.excel_ngay_sinh_ngh,
                      scope.row.excel_thang_sinh_ngh,
                      scope.row.excel_nam_sinh_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_ngay_sinh_ngh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_thang_sinh_ngh"
              label="Tháng sinh (người giám hộ)"
              align="right"
              width="150"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_thang_sinh_ngh',
                      scope.row.excel_ngay_sinh_ngh,
                      scope.row.excel_thang_sinh_ngh,
                      scope.row.excel_nam_sinh_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_thang_sinh_ngh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_nam_sinh_ngh"
              label="Năm sinh (người giám hộ)"
              align="right"
              width="150"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_nam_sinh_ngh',
                      scope.row.excel_nam_sinh_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_nam_sinh_ngh }}</span
                >
              </template>
            </el-table-column>
            <!-- <el-table-column prop="excel_ngay_sinh_ngh" label="Ngày sinh (người giám hộ)" width="150"></el-table-column> -->
            <el-table-column
              prop="excel_gioi_tinh_ngh"
              label="Giới tính (người giám hộ)"
              width="120"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_gioi_tinh_ngh',
                      scope.row.excel_gioi_tinh_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_gioi_tinh_ngh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_loai_giay_to_ngh"
              label="Loại giấy tờ"
              align="center"
              width="80"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_loai_giay_to_ngh',
                      scope.row.excel_loai_giay_to_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_loai_giay_to_ngh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_so_giay_to_ngh"
              label="Số giấy tờ (người giám hộ)"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    fn_formatterTableExcelKhachDuLich(
                      scope.row,
                      'excel_so_giay_to_ngh',
                      scope.row.excel_so_giay_to_ngh,
                      scope.row.excel_ngay_sinh,
                      scope.row.excel_thang_sinh,
                      scope.row.excel_nam_sinh
                    )
                  "
                  >{{ scope.row.excel_so_giay_to_ngh }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="excel_so_dien_thoai_ngh"
              label="Số điện thoại (người giám hộ)"
              width="120"
            ></el-table-column>
            <el-table-column
              prop="excel_so_the_bhyt_ngh"
              label="Số thẻ BHYT (người giám hộ)"
              align="center"
              width="120"
            >
              <!-- <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelKhachDuLich('excel_ngay_cap', scope.row.excel_ngay_cap, scope.row.excel_thang_cap, scope.row.excel_nam_cap)"
                >{{scope.row.excel_ngay_cap}}</span>
              </template>-->
            </el-table-column>
            <el-table-column
              prop="excel_quoc_tich_ngh"
              label="Quốc tịch (người giám hộ)"
              align="left"
              width="120"
            >
              <!-- <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelKhachDuLich('excel_thang_cap', scope.row.excel_ngay_cap, scope.row.excel_thang_cap, scope.row.excel_nam_cap)"
                >{{scope.row.excel_thang_cap}}</span>
              </template>-->
            </el-table-column>
            <el-table-column
              prop="excel_ma_quoc_gia_ngh"
              label="Mã quốc gia (người giám hộ)"
              align="center"
              width="120"
            >
              <!-- <template slot-scope="scope">
                <span
                  :class="fn_formatterTableExcelKhachDuLich('excel_ngay_het_han', scope.row.excel_ngay_het_han, scope.row.excel_thang_het_han, scope.row.excel_nam_het_han)"
                >{{scope.row.excel_ngay_het_han}}</span>
              </template>-->
            </el-table-column>
            <el-table-column
              fixed="right"
              label="Duyệt"
              align="center"
              v-if="mData.dialogKhachDuLich.hasError"
            >
              <template slot-scope="scope">
                <i
                  class="el-icon-error"
                  style="color: #e01219"
                  v-if="!scope.row.check"
                ></i>
                <i
                  class="el-icon-success"
                  style="color: #19d916"
                  v-if="scope.row.check"
                ></i>
              </template>
            </el-table-column>
          </el-table>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              v-ladda
              @click="fn_addValueKhachDuLich"
              :disabled="mData.dialogKhachDuLich.hasError"
              >Cấp mã</el-button
            >
            <!-- <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>-->

            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import MsKhachDuLichModel from "./MsKhachDuLichModel";
import MsKhachDuLichApi from "../../../moduleApi/MsKhachDuLichApi";
import { data } from 'jquery';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      aExtension: ExtensionService,
      mData: {
        viewMode: "create",
        moduleName: "MsKhachDuLich",
        dataDefault: {
          roles: DataService.rolesInForm,
          sended: false,
          color: { active: "#4287f5", error: "#f53131" },
        },
        dataForm: MethodService.copyObject(MsKhachDuLichModel.dataForm),
        validForm: MsKhachDuLichModel.validForm,
        dialog: {},
        dialogKhachDuLich: {
          list: [],
          visible: false,
          hasError: false,
        },
        excelKhachDuLich: MethodService.copyObject(
          MsKhachDuLichModel.excelKhachDuLich
        ),
        fileUploadOption: {
          // AnhDaiDien: {
          //   limit: 1,
          //   accept: ".jpg, .png, .jpeg",
          //   dialogImageUrl: "",
          //   dialogVisible: false,
          //   fileList: []
          // },
          // AnhTour: {
          //   limit: null,
          //   accept: ".jpg, .png, .jpeg",
          //   dialogImageUrl: "",
          //   dialogVisible: false,
          //   fileList: []
          // },
          // ThongTinDieuTour: {
          //   limit: null,
          //   accept: "",
          //   dialogImageUrl: "",
          //   dialogVisible: false,
          //   fileList: []
          // },
          // HoSoTour: {
          //   limit: null,
          //   accept: "",
          //   dialogImageUrl: "",
          //   dialogVisible: false,
          //   fileList: []
          // },

          DsKhachDuLich: {
            limit: 1,
            accept: ".xlsx",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            await MsKhachDuLichApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await MsKhachDuLichApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      // let res = await MsKhachDuLichApi.findById(id, "id,code,name,index");
      // this.mData.dataForm = res.result;
    },

    async fn_uploadChangeDsKhachDuLich(file, fileList) {
      this.mData.dataDefault.sended = false;
      let valueFile = await MethodService.readExcel(file.raw);
      if (valueFile.length > 1) {
        this.fn_formatExcelRow(valueFile);
      } else {
        toastr.error("Dữ liệu trong file trống");
      }
    },

    fn_formatExcelRow(valueFile) {
      // merge từ index excel sang tên code: value
      var arrKhachDuLich = [];
      $.each(valueFile, (iFile, elFile) => {
        let newObject = {};
        if (iFile > 0) {
          $.each(elFile, (iFileItem, elFileItem) => {
            $.each(
              this.mData.excelKhachDuLich.configIndex,
              (iModel, elModel) => {
                if (iFileItem == elModel.index) {
                  newObject[elModel.code] = elFileItem;
                }
              }
            );
          });
          arrKhachDuLich.push(newObject);
        }
      });
      this.mData.dialogKhachDuLich.list = arrKhachDuLich;
      this.mData.dialogKhachDuLich.visible = true;
      this.mData.dialogKhachDuLich.hasError = false;
    },

    async fn_addValueKhachDuLich() {
      var arrNew = [];

      $.each(this.mData.dialogKhachDuLich.list, (iKhach, elKhach) => {
        let objNew = MethodService.copyObject(
          MsKhachDuLichModel.excelKhachDuLich.formModel
        );

        objNew.LastName = elKhach.excel_ho_dem ? elKhach.excel_ho_dem : "";
        objNew.FirstName = elKhach.excel_ten ? elKhach.excel_ten : "";
        // objNew.Dob = elKhach.excel_ngay_sinh;?
        objNew.GenderId = ""; //elKhach.excel_gioi_tinh?elKhach.excel_gioi_tinh:"";
        objNew.CmndNumber = objNew.PassportNo = objNew.PaperType = "";
        if (elKhach.excel_loai_giay_to) {
          if (
            elKhach.excel_loai_giay_to == "CMT" ||
            elKhach.excel_loai_giay_to == "CCCD"
          ) {
            objNew.CmndNumber = elKhach.excel_so_giay_to;
          } else {
            objNew.PassportNo = elKhach.excel_so_giay_to
              ? elKhach.excel_so_giay_to
              : "";
          }
          objNew.PaperType = elKhach.excel_loai_giay_to;
        }

        objNew.Mobile = elKhach.excel_dien_thoai
          ? elKhach.excel_dien_thoai
          : "";
        objNew.BhytNumber = elKhach.excel_so_the_bhyt
          ? elKhach.excel_so_the_bhyt
          : "";
        objNew.NationalityName = elKhach.excel_quoc_tich
          ? elKhach.excel_quoc_tich
          : "";
        objNew.Dob =
          elKhach.excel_nam_sinh &&
          elKhach.excel_thang_sinh &&
          elKhach.excel_ngay_sinh
            ? parseInt(
                elKhach.excel_nam_sinh +
                  elKhach.excel_thang_sinh.toString().padStart(2, "0") +
                  elKhach.excel_ngay_sinh.toString().padStart(2, "0") +
                  "000000"
              )
            : "";
        objNew.NationalityCode = elKhach.excel_ma_quoc_gia
          ? elKhach.excel_ma_quoc_gia
          : "";
        if (elKhach.excel_gioi_tinh) {
          let gioiTinh = DataService.gioiTinh.find((element) => {
            return element.text == elKhach.excel_gioi_tinh;
          });
          if (gioiTinh) {
            objNew.GenderId = gioiTinh.id;
          }
        }
        if (
          elKhach.excel_ho_dem_ngh ||
          elKhach.excel_ten_ngh ||
          elKhach.excel_nam_sinh_ngh ||
          elKhach.excel_thang_sinh_ngh ||
          elKhach.excel_ngay_sinh_ngh ||
          elKhach.excel_so_giay_to_ngh ||
          elKhach.excel_so_dien_thoai_ngh ||
          elKhach.excel_so_the_bhyt_ngh ||
          elKhach.excel_quoc_tich_ngh ||
          elKhach.excel_loai_giay_to_ngh ||
          elKhach.excel_ma_quoc_gia_ngh ||
          elKhach.excel_gioi_tinh_ngh
        ) {
          objNew.Guardian.LastName = elKhach.excel_ho_dem_ngh
            ? elKhach.excel_ho_dem_ngh
            : "";
          objNew.Guardian.FirstName = elKhach.excel_ten_ngh
            ? elKhach.excel_ten_ngh
            : "";
          objNew.Guardian.Dob =
            elKhach.excel_nam_sinh_ngh &&
            elKhach.excel_thang_sinh_ngh &&
            elKhach.excel_ngay_sinh_ngh
              ? parseInt(
                  elKhach.excel_nam_sinh_ngh +
                    elKhach.excel_thang_sinh_ngh.toString().padStart(2, "0") +
                    elKhach.excel_ngay_sinh_ngh.toString().padStart(2, "0") +
                    "000000"
                )
              : "";
          objNew.Guardian.GenderId = ""; //elKhach.excel_gioi_tinh_ngh?elKhach.excel_gioi_tinh_ngh:"";
          objNew.Guardian.CmndNumber = objNew.Guardian.PassportNo = objNew.Guardian.PaperType =
            "";
          if (elKhach.excel_loai_giay_to_ngh) {
            if (
              elKhach.excel_loai_giay_to_ngh == "CMT" ||
              elKhach.excel_loai_giay_to_ngh == "CCCD"
            ) {
              objNew.Guardian.CmndNumber = elKhach.excel_so_giay_to_ngh;
            } else {
              objNew.Guardian.PassportNo = elKhach.excel_so_giay_to_ngh;
            }
            objNew.Guardian.PaperType = elKhach.excel_loai_giay_to_ngh;
          }

          objNew.Guardian.Mobile = elKhach.excel_so_dien_thoai_ngh
            ? elKhach.excel_so_dien_thoai_ngh
            : "";
          objNew.Guardian.BhytNumber = elKhach.excel_so_the_bhyt_ngh
            ? elKhach.excel_so_the_bhyt_ngh
            : "";
          objNew.Guardian.NationalityName = elKhach.excel_quoc_tich_ngh
            ? elKhach.excel_quoc_tich_ngh
            : "";
          objNew.Guardian.NationalityCode = elKhach.excel_ma_quoc_gia_ngh
            ? elKhach.excel_ma_quoc_gia_ngh
            : "";

          if (elKhach.excel_gioi_tinh_ngh) {
            let gioiTinhNgh = DataService.gioiTinh.find((element) => {
              return element.text == elKhach.excel_gioi_tinh_ngh;
            });
            if (gioiTinhNgh) {
              objNew.Guardian.GenderId = gioiTinhNgh.id;
            }
          }
        } else {
          objNew.Guardian = null;
        }

        arrNew.push(objNew);
      });
      // debugger;
      let resImport = await MsKhachDuLichApi.registerMsKhachDuLich(
        arrNew
        // this.mData.dataForm.id
      );
      // debugger;
      if (resImport.result && resImport.result == true) {
        toastr.success(LanguageService.lang.c_addCodeSuccess);
        if (resImport.meta && resImport.meta.cos) {
          let cache = JSON.parse(resImport.meta.cos);
          this.mData.dialogKhachDuLich.list.forEach(async (item) => {
            let cacheItem = {
              last_name: item.excel_ho_dem ? item.excel_ho_dem : "",
              first_name: item.excel_ten ? item.excel_ten : "",
              gioi_tinh: item.excel_gioi_tinh ? DataService.gioiTinh.find(
                (gt) => gt.text == item.excel_gioi_tinh
              ).id : "",
              cmnd_number: item.excel_so_giay_to ? item.excel_so_giay_to : "",
              mobile: item.excel_dien_thoai ? item.excel_dien_thoai : "",
              bhyt_number: item.excel_so_the_bhyt ? item.excel_so_the_bhyt : "",
              nationality_name: item.excel_quoc_tich
                ? item.excel_quoc_tich
                : "",
              dob:
                item.excel_nam_sinh &&
                item.excel_thang_sinh &&
                item.excel_ngay_sinh
                  ? parseInt(
                      item.excel_nam_sinh +
                        item.excel_thang_sinh.toString().padStart(2, "0") +
                        item.excel_ngay_sinh.toString().padStart(2, "0") +
                        "000000"
                    )
                  : "",
              passport_no: item.excel_so_ho_chieu ? item.excel_so_ho_chieu : "",
              nationality_code: item.excel_ma_quoc_gia
                ? item.excel_ma_quoc_gia
                : "",
              guardian: {
                last_name: item.excel_ho_dem_ngh ? item.excel_ho_dem_ngh : "",
                first_name: item.excel_ten_ngh ? item.excel_ten_ngh : "",
                gioi_tinh: item.excel_gioi_tinh_ngh ? DataService.gioiTinh.find(
                  (gt) => gt.text == item.excel_gioi_tinh_ngh
                ).id : "",
                mobile: item.excel_so_dien_thoai_ngh
                  ? item.excel_so_dien_thoai_ngh
                  : "",
                bhyt_number: item.excel_so_the_bhyt_ngh
                  ? item.excel_so_the_bhyt_ngh
                  : "",
                cmnd_number: item.excel_so_giay_to_ngh
                  ? item.excel_so_giay_to_ngh
                  : "",
                dob:
                  item.excel_nam_sinh_ngh &&
                  item.excel_thang_sinh_ngh &&
                  item.excel_ngay_sinh_ngh
                    ? parseInt(
                        item.excel_nam_sinh_ngh +
                          item.excel_thang_sinh_ngh
                            .toString()
                            .padStart(2, "0") +
                          item.excel_ngay_sinh_ngh.toString().padStart(2, "0") +
                          "000000"
                      )
                    : "",
                nationality_name: item.excel_quoc_tich_ngh
                  ? item.excel_quoc_tich_ngh
                  : "",
                nationality_code: item.excel_ma_quoc_gia_ngh
                  ? item.excel_ma_quoc_gia_ngh
                  : "",
                passport_no: item.excel_so_ho_chieu_ngh
                  ? item.excel_so_ho_chieu_ngh
                  : "",
              },
            };
            let rowData = cache.find(
              (data) =>
                data.last_name == cacheItem.last_name &&
                data.first_name == cacheItem.first_name &&
                data.gioi_tinh == cacheItem.gioi_tinh && 
                (
                  (data.cmnd_number && data.cmnd_number == cacheItem.cmnd_number) ||
                  (!data.cmnd_number && !cacheItem.cmnd_number)
                ) &&
                data.mobile == cacheItem.mobile &&
                data.bhyt_number == cacheItem.bhyt_number &&
                data.nationality_name == cacheItem.nationality_name &&
                data.dob == cacheItem.dob &&
                data.passport_no == cacheItem.passport_no &&
                data.nationality_code == cacheItem.nationality_code &&
                ((
                  !data.guardian && 
                  !cacheItem.guardian.last_name &&
                  !cacheItem.guardian.first_name &&
                  !cacheItem.guardian.gioi_tinh &&
                  !cacheItem.guardian.mobile &&
                  !cacheItem.guardian.bhyt_number &&
                  !cacheItem.guardian.cmnd_number &&
                  !cacheItem.guardian.dob &&
                  !cacheItem.guardian.nationality_name &&
                  !cacheItem.guardian.nationality_code &&
                  !cacheItem.guardian.passport_no
                ) || (
                  data.guardian &&
                  data.guardian.last_name == cacheItem.guardian.last_name &&
                  data.guardian.first_name == cacheItem.guardian.first_name &&
                  data.guardian.gioi_tinh == cacheItem.guardian.gioi_tinh &&
                  data.guardian.mobile == cacheItem.guardian.mobile &&
                  data.guardian.bhyt_number == cacheItem.guardian.bhyt_number &&
                  data.guardian.cmnd_number == cacheItem.guardian.cmnd_number &&
                  data.guardian.dob == cacheItem.guardian.dob &&
                  data.guardian.nationality_name == cacheItem.guardian.nationality_name &&
                  data.guardian.nationality_code == cacheItem.guardian.nationality_code &&
                  data.guardian.passport_no == cacheItem.guardian.passport_no
                ))
            );
            cache = cache.filter((data, index) => {
              return index != cache.indexOf(rowData);
            });
            if (rowData) {
              item["status"] = "Dữ liệu không hợp lệ!";
              item["reason"] = rowData.reason;
            } else {
              item["status"] = "Cấp mã thành công";
            }
          });
          this.mData.dataDefault.sended = true;
        } else {
          this.mData.dialogKhachDuLich.list.forEach((item) => {
            item["status"] = "Cấp mã thành công";
          });
          this.mData.dataDefault.sended = true;
        }
      } else {
        toastr.error(LanguageService.lang.c_findError);
      }
      this.mData.dialogKhachDuLich.visible = false;

      // this.fn_getDataById(this.mData.dataForm.id);
    },
    fn_uploadExceedDsKhachDuLich(files, fileList) {
      this.mData.dataDefault.sended = false;
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.DsKhachDuLich.limit} file`
      );
    },
    fn_formatterTableExcelKhachDuLich(
      scope,
      colName,
      colVal,
      colVal2,
      colVal3,
      colVal4,
      colVal5,
      colVal6,
      colVal7
    ) {
      if (colName == "excel_ho_dem") {
        if (!colVal) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_ten") {
        if (!colVal) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      // if (colName == "excel_dien_thoai") {
      //   if (colVal && !MethodService.checkSDT(colVal)) {
      //     this.mData.dialogKhachDuLich.hasError = true;
      //     return "bg-danger bg-column";
      //   }
      // }
      // if (colName == "excel_so_the") {
      //   if (colVal && colVal.length != 9 && colVal.length != 16) {
      //     this.mData.dialogKhachDuLich.hasError = true;
      //     return "bg-danger bg-column";
      //   }
      // }
      if (colName == "excel_ngay_sinh") {
        //colVal = ngay, colVal2 = thang, colVal3 = nam
        if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_thang_sinh") {
        if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_nam_sinh") {
        if (!colVal) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_loai_giay_to") {
        if (!colVal && MethodService.getAge(colVal4, colVal3, colVal2) >= 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_so_giay_to") {
        if (!colVal && MethodService.getAge(colVal4, colVal3, colVal2) >= 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_gioi_tinh") {
        if (!colVal) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }

      if (colName == "excel_ho_dem_ngh") {
        if (!colVal && MethodService.getAge(colVal4, colVal3, colVal2) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_ten_ngh") {
        if (!colVal && MethodService.getAge(colVal4, colVal3, colVal2) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }

      if (colName == "excel_ngay_sinh_ngh") {
        //colVal = ngay, colVal2 = thang, colVal3 = nam
        if (
          !MethodService.checkIsDate(colVal, colVal2, colVal3) &&
          colVal3 != null &&
          colVal2 != null
        ) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else if (MethodService.getAge(colVal7, colVal6, colVal5) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_thang_sinh_ngh") {
        if (
          !MethodService.checkIsDate(colVal, colVal2, colVal3) &&
          colVal3 != null &&
          colVal2 != null
        ) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else if (MethodService.getAge(colVal7, colVal6, colVal5) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      if (colName == "excel_nam_sinh_ngh") {
        if (!colVal && MethodService.getAge(colVal7, colVal6, colVal5) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }

      if (colName == "excel_gioi_tinh_ngh") {
        if (!colVal && MethodService.getAge(colVal4, colVal3, colVal2) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }

      if (colName == "excel_so_giay_to_ngh") {
        if (!colVal && MethodService.getAge(colVal4, colVal3, colVal2) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }

      if (colName == "excel_loai_giay_to_ngh") {
        if (!colVal && MethodService.getAge(colVal4, colVal3, colVal2) < 16) {
          this.mData.dialogKhachDuLich.hasError = true;
          scope["check"] = false;
          return "bg-danger bg-column";
        } else {
          if (scope["check"] == undefined) {
            scope["check"] = true;
          }
        }
      }
      // if (colName == "excel_ngay_sinh_ngh") {
      //   //colVal = ngay, colVal2 = thang, colVal3 = nam
      //   if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
      //     this.mData.dialogKhachDuLich.hasError = true;
      //     return "bg-danger bg-column";
      //   }
      // }
      // if (colName == "excel_thang_sinh_ngh") {
      //   if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
      //     this.mData.dialogKhachDuLich.hasError = true;
      //     return "bg-danger bg-column";
      //   }
      // }
      // if (colName == "excel_nam_sinh_ngh") {
      //   if (!colVal) {
      //     this.mData.dialogKhachDuLich.hasError = true;
      //     return "bg-danger bg-column";
      //   }
      // }
      // if (colName == "excel_ngay_cap") {
      //   //
      //   //colVal = ngay, colVal2 = thang, colVal3 = nam
      //   if (colVal != null) {
      //     if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
      //       this.mData.dialogKhachDuLich.hasError = true;
      //       return "bg-danger bg-column";
      //     }
      //   }
      // }
      // if (colName == "excel_thang_cap") {
      //   if (colVal2 != null) {
      //     if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
      //       this.mData.dialogKhachDuLich.hasError = true;
      //       return "bg-danger bg-column";
      //     }
      //   }
      // }
      // if (colName == "excel_nam_cap") {
      //   if (colVal3 != null) {
      //     if (!colVal) {
      //       this.mData.dialogKhachDuLich.hasError = true;
      //       return "bg-danger bg-column";
      //     }
      //   }
      // }
      // if (colName == "excel_ngay_het_han") {
      //   //colVal = ngay, colVal2 = thang, colVal3 = nam
      //   if (colVal != null) {
      //     if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
      //       this.mData.dialogKhachDuLich.hasError = true;
      //       return "bg-danger bg-column";
      //     }
      //   }
      // }
      // if (colName == "excel_thang_het_han") {
      //   if (colVal2 != null) {
      //     if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
      //       this.mData.dialogKhachDuLich.hasError = true;
      //       return "bg-danger bg-column";
      //     }
      //   }
      // }
      // if (colName == "excel_nam_het_han") {
      //   if (colVal3 != null) {
      //     if (!MethodService.checkIsDate(colVal, colVal2, colVal3)) {
      //       this.mData.dialogKhachDuLich.hasError = true;
      //       return "bg-danger bg-column";
      //     }
      //   }
      // }
    },

    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_errorRow({ row, rowIndex }) {
      if (row.reason) {
        return "error-row";
      } else {
        return "";
      }
    },
  },
  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>

<style lang="scss">
.el-table {
  .error-row {
    background-color: oldlace !important;
  }
}
</style>